import { render, staticRenderFns } from "./StatisticsVisits.vue?vue&type=template&id=7f5b7110"
import script from "./StatisticsVisits.vue?vue&type=script&lang=js"
export * from "./StatisticsVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports